import { buildMirror } from "@/lib/mirror/build"

/* This data structure is for storing multiple formats of the same data
   together, which allows us to work with it in the most useful format
   for a given operation.

   When changes occur, it's generally better to build a new version of
   the Mirror rather than try to edit the existing one.

   To help prevent this, we freeze each Mirror when we build it.
*/
export type Mirror<Element> = {
  array: Readonly<Element[]>
  collection: Readonly<Record<Mirror.Key, Element>>
}

export namespace Mirror {
  export const build = buildMirror

  export type Collection<Element> = Record<Key, Element>

  export type Format<Element> = Collection<Element> | Element[]

  export type FormatId = `array` | `collection`

  export type Key = string

  export type Options<Element> = Element extends {
    id: string
  }
    ? {
        extractKey?: Mirror.Functions.ExtractKey
      }
    : {
        extractKey: Mirror.Functions.ExtractKey
      }

  export namespace Functions {
    export type ExtractKey = <Element>(record: Element) => Key
  }
}
